import { useQuery } from '@tanstack/react-query';
import { IImageTemplate } from '../../../models/ImageTemplate';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'admin/template/<systemTemplateId>/imageTemplate';

export function useAdminImageTemplateBySystemTemplateQuery({ systemTemplateId }: { systemTemplateId?: string }) {
	const userSession = useUserSession();
	return useQuery({
		enabled: !!systemTemplateId,
		// These routes drop null fields, so a template with no deck answers with no value at all.
		queryFn: async () =>
			(await userSession.webServiceHelper.callAsync<IImageTemplate>({
				path: `admin/template/${encodeURIComponent(systemTemplateId)}/imageTemplate`,
				method: 'GET',
				throwOn404: false,
			})) ?? null,
		queryKey: [BASE_QUERY_KEY, systemTemplateId],
		meta: {
			toastErrorMessage: "Couldn't load this template's design.",
			errorLogging: { category: 'ImageTemplate', action: 'AdminImageTemplateBySystemTemplateQuery-Error' },
		},
	});
}

export const invalidateAdminImageTemplateBySystemTemplate = (systemTemplateId: string) =>
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, systemTemplateId] });
